/**
 * Turns trending topic / word-frequency rows into word-cloud tokens.
 */
export class BotWordCloudViewModel {
  /**
   * @param {Array<{ word?: string, count?: number | null, frequency?: number | null }>} rows
   * @returns {Array<{ word: string, count: number, fontPx: number }>}
   */
  build(rows) {
    const list = Array.isArray(rows) ? rows : [];
    const tokens = list
      .map((row) => {
        const word = String(row?.word ?? row?.topic ?? row?.label ?? "").trim();
        const count = Number(row?.count ?? row?.frequency ?? 0) || 0;
        return { word, count };
      })
      .filter((t) => t.word);
    const max = Math.max(1, ...tokens.map((t) => t.count));
    return tokens.map((t) => ({
      ...t,
      fontPx: Math.round(12 + (t.count / max) * 22),
    }));
  }
}
